import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

   constructor(
      private http: HttpClient,
      private session: SessionService,
    ) {
      try {
        environment.API_URL = this.session.GetUserDetails().ApiUrl;
      } catch (e) { }
    }
  
    ESS_RouteMaster(ComboDetail: any) {
      return this.http.post<any>(environment.API_URL + `ESS_RouteMaster/Load`,
        this.session.SetClass(ComboDetail)
      ).pipe(map(response => {
        if (response.Error_Code == '11' || response.Error_Code == '02') {
          this.session.End();
        } else {
          return response;
        }
      }));
    }
  
    ESS_RouteMaster_Insert(ComboDetail: any) {
      return this.http.post<any>(environment.API_URL + `ESS_RouteMaster_Insert/Update`,
        this.session.SetClass(ComboDetail)
      ).pipe(map(response => {
        if (response.Error_Code == '11' || response.Error_Code == '02') {
          this.session.End();
        } else {
          return response;
        }
      }));
    }
  
}
